/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICRTouchConnectionSites
 */
export interface ICRTouchConnectionSites {
    /**
     * 
     * @type {number}
     * @memberof ICRTouchConnectionSites
     */
    siteNumber: number;
    /**
     * 
     * @type {string}
     * @memberof ICRTouchConnectionSites
     */
    siteName: string;
}

/**
 * Check if a given object implements the ICRTouchConnectionSites interface.
 */
export function instanceOfICRTouchConnectionSites(value: object): value is ICRTouchConnectionSites {
    if (!('siteNumber' in value) || value['siteNumber'] === undefined) return false;
    if (!('siteName' in value) || value['siteName'] === undefined) return false;
    return true;
}

export function ICRTouchConnectionSitesFromJSON(json: any): ICRTouchConnectionSites {
    return ICRTouchConnectionSitesFromJSONTyped(json, false);
}

export function ICRTouchConnectionSitesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICRTouchConnectionSites {
    if (json == null) {
        return json;
    }
    return {
        
        'siteNumber': json['siteNumber'],
        'siteName': json['siteName'],
    };
}

  export function ICRTouchConnectionSitesToJSON(json: any): ICRTouchConnectionSites {
      return ICRTouchConnectionSitesToJSONTyped(json, false);
  }

  export function ICRTouchConnectionSitesToJSONTyped(value?: ICRTouchConnectionSites | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'siteNumber': value['siteNumber'],
        'siteName': value['siteName'],
    };
}

